(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/router.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/router.js');
"use strict";


const Router = svs.app.ReactRouter.PlayerRouter;
const Route = svs.app.ReactRouter.Route;
const _svs$ticket_partner$d = svs.ticket_partner.digitalTickets,
  DigitalTickets = _svs$ticket_partner$d.DigitalTickets,
  DigitalTicketsReceipt = _svs$ticket_partner$d.DigitalTicketsReceipt;
const HeaderPortal = svs.ticket_partner.sharedComponents.headerPortal.HeaderPortal;
const PhysicalTickets = svs.ticket_partner.physicalTickets.PhysicalTickets;
const Receipt = svs.ticket_partner.physicalTickets.receipt.Receipt;
const Login = svs.ticket_partner.login.Login;
const Start = svs.ticket_partner.start.StartPage;
const MyOrders = svs.ticket_partner.myOrders.MyOrders;
const CompanyDetails = svs.ticket_partner.companyDetails.CompanyDetails;
const PasswordRecovery = svs.ticket_partner.passwordRecovery.PasswordRecovery;
const ChangePassword = svs.ticket_partner.changePassword.ChangePassword;
const Menu = svs.ticket_partner.sharedComponents.menu.Menu;
const Footer = svs.ticket_partner.sharedComponents.footer.Footer;
const _ref = svs.ticket_partner.constants.routes || {},
  DIGITAL_TICKETS = _ref.DIGITAL_TICKETS,
  DIGITAL_TICKETS_RECEIPT = _ref.DIGITAL_TICKETS_RECEIPT,
  PHYSICAL_TICKETS = _ref.PHYSICAL_TICKETS,
  PHYSICAL_TICKETS_RECEIPT = _ref.PHYSICAL_TICKETS_RECEIPT,
  LOGIN = _ref.LOGIN,
  PASSWORD_RECOVERY = _ref.PASSWORD_RECOVERY,
  MY_ORDERS = _ref.MY_ORDERS,
  COMPANY_DETAILS = _ref.COMPANY_DETAILS,
  CHANGE_PASSWORD = _ref.CHANGE_PASSWORD;
const _svs$ticket_partner = svs.ticket_partner,
  CompanyDetailsProvider = _svs$ticket_partner.CompanyDetailsProvider,
  DigitalTicketsProvider = _svs$ticket_partner.DigitalTicketsProvider,
  PhysicalTicketsProvider = _svs$ticket_partner.PhysicalTicketsProvider,
  UserProvider = _svs$ticket_partner.UserProvider;
const PrivateRoute = svs.ticket_partner.sharedComponents.privateRoute.PrivateRoute;
const _svs$ticket_partner$c = svs.ticket_partner.constants.localStorageKey,
  B2B_ONE_TIME_PASSWORD_LOCAL_STORAGE_KEY = _svs$ticket_partner$c.B2B_ONE_TIME_PASSWORD_LOCAL_STORAGE_KEY,
  DIGITAL_TICKETS_LOCAL_STORAGE_KEY = _svs$ticket_partner$c.DIGITAL_TICKETS_LOCAL_STORAGE_KEY,
  PHYSICAL_TICKETS_LOCAL_STORAGE_KEY = _svs$ticket_partner$c.PHYSICAL_TICKETS_LOCAL_STORAGE_KEY;
const MenuWithLogout = () => {
  const _svs$ticket_partner$u = svs.ticket_partner.useUserContext(),
    logout = _svs$ticket_partner$u.logout,
    isLoggedIn = _svs$ticket_partner$u.isLoggedIn;
  const onLogout = () => {
    window.localStorage.removeItem(B2B_ONE_TIME_PASSWORD_LOCAL_STORAGE_KEY);
    window.localStorage.removeItem(DIGITAL_TICKETS_LOCAL_STORAGE_KEY);
    window.localStorage.removeItem(PHYSICAL_TICKETS_LOCAL_STORAGE_KEY);
    logout();
  };
  return React.createElement(Menu, {
    isLoggedIn: isLoggedIn,
    logout: onLogout
  });
};
const TicketPartnerRouter = () => React.createElement(Router, {
  basename: svs.core.data.baseUrl
}, React.createElement(UserProvider, null, React.createElement(HeaderPortal, null), React.createElement(MenuWithLogout, null), React.createElement("div", {
  className: "align-center ticket-partner-page f-content"
}, React.createElement(Route, {
  component: Start,
  exact: true,
  path: "/"
}), React.createElement(DigitalTicketsProvider, null, React.createElement(Route, {
  component: DigitalTickets,
  exact: true,
  path: DIGITAL_TICKETS
}), React.createElement(Route, {
  component: DigitalTicketsReceipt,
  exact: true,
  path: DIGITAL_TICKETS_RECEIPT
})), React.createElement(PhysicalTicketsProvider, null, React.createElement(Route, {
  component: PhysicalTickets,
  exact: true,
  path: PHYSICAL_TICKETS
}), React.createElement(Route, {
  component: Receipt,
  exact: true,
  path: PHYSICAL_TICKETS_RECEIPT
})), React.createElement(CompanyDetailsProvider, null, React.createElement(PrivateRoute, {
  component: CompanyDetails,
  exact: true,
  path: COMPANY_DETAILS
})), React.createElement(Route, {
  component: Login,
  exact: true,
  path: LOGIN
}), React.createElement(Route, {
  component: PasswordRecovery,
  exact: true,
  path: PASSWORD_RECOVERY
}), React.createElement(Route, {
  component: ChangePassword,
  exact: true,
  path: CHANGE_PASSWORD
}), React.createElement(PrivateRoute, {
  component: MyOrders,
  exact: true,
  path: MY_ORDERS
}), React.createElement(Footer, null))));
svs.ticket_partner.Router = TicketPartnerRouter;

 })(window);